<div class="background row">
    <div class="banner-img  col-md-6 col-12">
        <nav class="navbar navbar-mob">
            <h6 class="Ws-logo-mobile">{{constants.WINDOW_SWAP_TXT}}</h6>
        </nav>
        <img *ngIf="from !== 'signup,%23'" [src]="constants.SIGNUP_PAGE_IMG" alt="">
        <img *ngIf="from === 'signup,%23'" [src]="constants.SUBMIT_LOGIN_IMG" alt="">
        <p *ngIf="from !== 'signup,%23'" class="author">{{constants.TAG_1_TXT}}</p>
        <p *ngIf="from === 'signup,%23'" class="author">{{constants.TAG_2_TXT}}</p>
    </div>
    <div class=" col-md-6 col-12 signup-form" (click)="onClickFormArea()" *ngIf="!registerSuccess">
        <nav class="navbar navbar-light">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </nav>
        <div class="container form-area">
            <h2 *ngIf="from !== 'signup,%23' && !fromPricing" class="heading animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_HEADING_TXT}}</h2>
            <h2 *ngIf="from === 'signup,%23' && !fromPricing" class="heading animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_HEADING_1_TXT}}</h2>
            <p *ngIf="fromPricing" class="content mb-0 heading animate__animated animate__fadeInUp">STEP-1</p>
            <h3 *ngIf="fromPricing" class="heading mb-0 pb-0 heading animate__animated animate__fadeInUp">
                {{constants.CREATE_ACCOUNT}}</h3>
            <li *ngIf="from !== 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_1_TXT}}</li>
            <li *ngIf="from !== 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_2_TXT}}
            </li>
            <li *ngIf="from !== 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_3_TXT}}
            </li>
            <li *ngIf="from !== 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_4_TXT}}
            </li>
            <li *ngIf="from === 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_1_1_TXT}}
            </li>
            <li *ngIf="from === 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_1_2_TXT}}
            </li>
            <li *ngIf="from === 'signup,%23' && !fromPricing" class="content animate__animated animate__fadeInUp">
                {{constants.SIGN_UP_SUB_HEADING_1_3_TXT}}
            </li>
            <p class="existing animate__animated animate__fadeInUp">{{constants.ALREADY_TXT}}
                <a [routerLink]="['/login']">{{constants.LOGIN_TXT}}</a>
            </p>
            <div class="social-button-container">
                <button [disabled]="true" type="button"
                    class="btn btn-lg signup-button-fb animate__animated animate__fadeInUp"
                    (click)="onLoginClick('Facebook')">
                    <img class="facebook-img" [src]="constants.LOGIN_FACEBOOK_IMG" alt="">
                    {{constants.SIGNUP_FB}}
                </button>
                <button type="button" class="btn btn-lg signup-button animate__animated animate__fadeInUp"
                    (click)="onLoginClick('Google')">
                    <img class="google-img" [src]="constants.LOGIN_GOOGLE_IMG" alt="">
                    {{constants.SIGNUP_GOOGLE}}
                </button>
            </div>
            <div class="signup-text animate__animated animate__fadeInUp">{{constants.SIGNUP_EMAIL}}</div>
            <form class='login-email-form' [formGroup]="signupForm">
                <span class="input-text-required"
                    *ngIf="signupForm.get('email').errors?.required && (signupForm.get('email').dirty || signupForm.get('email').touched) ">
                    {{constants.EMAIL_ID}}<br></span>
                <span class="input-text-required" *ngIf="signupForm.get('email').errors?.email">
                    {{constants.INVALID_ID}} </span>
                <span class="input-text-required alreadytxt" id="alert-email">
                    {{constants.ANOTHER_EMAIL}} <a href="/login">{{constants.LOGIN_TXT_SIGNUP}}</a>
                </span>
                <input type="email" class="input-text animate__animated animate__fadeInUp"
                    placeholder="Your Email Address" formControlName="email" autocomplete="username">
                <span class="input-text-required"
                    *ngIf="signupForm.get('firstName').errors?.required && (signupForm.get('firstName').dirty || signupForm.get('firstName').touched) ">
                    {{constants.ENTER_NAME}}</span>
                <div class="name-container">
                    <input class="input-text animate__animated animate__fadeInUp" id="first-name" type="text"
                        placeholder="First Name" formControlName="firstName" autocomplete="given-name">
                    <input class="input-text animate__animated animate__fadeInUp" type="text" placeholder="Last Name"
                        formControlName="lastName" autocomplete="family-name">
                </div>
                <span class="input-text-required"
                    *ngIf="signupForm.get('password').errors?.required && (signupForm.get ('password').dirty || signupForm.get('password').touched) ">
                    {{constants.PASSWORD}}<br> </span>
                <span class="input-text-required" *ngIf="signupForm.get('password').errors?.pattern">
                    {{constants.STRONG_PASSWORD}}</span>
                <div class="password-container animate__animated animate__fadeInUp">
                    <input class="input-text " id="input-password" type="password" placeholder="Password"
                        formControlName="password" autocomplete="new-password">
                    <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
                </div>
                <button [disabled]="isProcessing || !signupForm.valid" (click)="onClickSignup()"
                    class="signup-email-button animate__animated animate__fadeInUp">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span> {{constants.JOIN_TXT}}</button>
            </form>
        </div>
    </div>
    <div class=" col-sm-6 col-12 signup-confirm-form" *ngIf="registerSuccess">
        <nav class="navbar navbar-light">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </nav>
        <div id="title-box-1" class="signup-confirm-margin">
            <h2 class="confirm-heading animate__animated animate__fadeInUp">Please click the link in the <br>
                verification link sent to your <br> email to confirm your account</h2>
            <p class="confirm-sub-heading animate__animated animate__fadeInUp">( If you can't find our mail in your
                Inbox, <br>please check your Junk Mail folder)</p>
            <span class="input-text-resend animate__animated animate__fadeInUp" id="resend-alert"><br></span>
            <button [disabled]="isDisabled" class="progress-button" id="resend" [ngClass]="{ 'enableResendBtn': !isDisabled }"
                [style.backgroundSize]="progress + '% 100%'" (click)="onClickResend()">
                {{constants.RESEND_BUTTON_TEXT}}
            </button>
            <span class="timer" *ngIf="isDisabled">Wait for <span style="font-weight: 600;">{{remainingTime}} seconds</span> to
                resend link</span>
            <p class="already-verified-txt">Already Verified on another device? <span [routerLink]="['/login']">Click
                    here to login</span></p>
        </div>
    </div>
</div>
<img (click)="gotoPrevious()" id="close-button" [src]="constants.BACK_BUTTON" alt="close-button" />